import { Box, Button, Collapse, TableCell, TableRow, Typography } from "@mui/material";
import React, { useState } from "react";
import appConfig from "src/config/env";
import { Create, KeyboardDoubleArrowDown } from "@mui/icons-material";
import useAppGlobal from "src/context/useAppGlobal";
import UpdatePercentageDialog from "./UpdatePercentageDialog";
import { PERMISSIONS, useRoleCheck } from "src/hooks/permission/permission";

export default function BalancePMPercentageTableRow({ productModels = [] }) {
  const permissionCheck = useRoleCheck();
  const { handleOpenDialog } = useAppGlobal();
  const [index, setIndex] = useState([]);

  const handleOpen = (value) => {
    setIndex((prev) => (prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value]));
  };

  const onUpdate = (chiildWarehouse, productModel) => {
    handleOpenDialog({
      title: "Cập nhật chi tiết dung tích sản phẩm",
      content: (
        <UpdatePercentageDialog
          chiildWarehouse={chiildWarehouse}
          productModel={productModel}
        />
      ),
      size: "md",
    });
  };

  return (
    <>
      {productModels?.map((item, i) => (
        <TableRow key={i + 1}>
          <TableCell align="center">
            <Box
              display="flex"
              gap={2}
            >
              <Box
                sx={{
                  width: "46px",
                  height: "46px",
                  background: `url(${appConfig.API_FILE}/${item?.imageUrl})`,
                  backgroundSize: "100%",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                  border: "1px solid var(--grey)",
                  borderRadius: "8px",
                }}
              />
              {item?.name ?? "-"}
            </Box>
          </TableCell>
          <TableCell align="left">
            <Typography
              component="button"
              variant="caption"
              sx={{ background: "transparent", border: 0, display: "flex", gap: 1, alignItems: "center", mb: index?.includes(i) ? 2 : 0 }}
              onClick={() => handleOpen(i)}
            >
              Tỉ lệ từng kho{" "}
              <KeyboardDoubleArrowDown
                sx={{
                  fontSize: 16,
                  transform: index?.includes(i) ? "rotate(180deg)" : "rotate(0deg)",
                  transition: "transform 0.2s ease",
                }}
              />
            </Typography>
            <Collapse
              in={index?.includes(i)}
              timeout="auto"
              unmountOnExit
              sx={{
                "&.MuiCollapse-root > .MuiCollapse-wrapper > .MuiCollapse-wrapperInner ": {
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  gap: 2,
                },
              }}
            >
              {item?.childWarehouses?.map((v) => {
                return (
                  <Box
                    key={v?._id}
                    display="flex"
                    alignItems="flex-start"
                    justifyContent="space-between"
                    width="100%"
                  >
                    <Typography
                      flex={1}
                      fontWeight={700}
                      variant="caption"
                    >
                      {v?.childWarehouse?.name}
                    </Typography>
                    <Button
                      disabled={!permissionCheck([PERMISSIONS.UPDATE_WAREHOUSE_ALL, PERMISSIONS.UPDATE_WAREHOUSE_OWN])}
                      onClick={() => onUpdate(v?._id, item?._id)}
                      size="small"
                      variant="outlined"
                      endIcon={<Create sx={{ fontSize: 8 }} />}
                      sx={{
                        minWidth: 0,
                        px: 1,
                        textTransform: "none",
                        justifyContent: "flex-start",
                        fontSize: "12px",
                      }}
                    >
                      {v?.percentage}%
                    </Button>
                  </Box>
                );
              })}
            </Collapse>
          </TableCell>
        </TableRow>
      ))}
    </>
  );
}
